import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=5f4bc12e&scoped=true&"
import script from "./uploadPhoto.vue?vue&type=script&lang=js&"
export * from "./uploadPhoto.vue?vue&type=script&lang=js&"
import style0 from "./uploadPhoto.vue?vue&type=style&index=0&id=5f4bc12e&scoped=true&lang=scss&"
import style1 from "./uploadPhoto.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4bc12e",
  null
  
)

export default component.exports